import { Dispatch, SetStateAction } from "react";
import { Col, Form } from "react-bootstrap";
import { capitalizeFirstLetter } from "../../hooks/helpers/helpers";

function ColorSelector<Value>({
  value,
  set,
  parse,
  label,
  colors,
  placeholder,
}: {
  value: Value;
  set: Dispatch<SetStateAction<Value>>;
  parse: (string: string) => Value;
  label: string;
  colors: Value[];
  /**
   * Getoond als niet-kiesbare optie wanneer de waarde niet in `colors` staat.
   * Zonder placeholder selecteert React dan de eerste kleur, terwijl de state
   * iets anders bevat.
   */
  placeholder?: string;
}) {
  const string = String(value);
  const onbekend =
    placeholder !== undefined && !colors.some((c) => String(c) === string);

  return (
    <Form.Group as={Col} xs={6} md={3}>
      <Form.Label>{label}</Form.Label>

      <select
        value={onbekend ? "" : string}
        className="select"
        style={{ padding: "8px 4px", position: "inherit" }}
        onChange={(e) => {
          const coerced = parse(e.target.value);
          set(coerced);
        }}
      >
        {onbekend && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {colors.map((item: any) => (
          <option value={item} key={item} className="select-item">
            {capitalizeFirstLetter(item)}
          </option>
        ))}
      </select>
    </Form.Group>
  );
}

export default ColorSelector;
